import { createElementIdSlice } from '../utils/action/createElementSlice';
export const TextFieldState = createElementIdSlice({
    elementName: 'text-field',
    initialState: {},
    reducers: {
        commitValue(state, action) {
            if (!state)
                return;
            return Object.assign(Object.assign({}, state), { committedValue: action.payload.data });
        },
        updateError(state, _action) {
            return state;
        },
    },
});
